<ion-app>
    <ion-router-outlet id="blank-content"></ion-router-outlet>
</ion-app>
